<template>
    <div class="single-position single index">

        <section class="heroSection -purple">
            <div class="positionHero__static uk-padding-remove">
                <div class="positionHero__top">
                    <div class="uk-container">
                        <div class="positionHero__titleSection">
                            <span class="positionHero__eyebrow -purple" v-if="deptinfo.post_title">
                                <a :href="return_url">{{ $t("message.positions") }}</a> / {{ deptinfo.post_title }}
                            </span>
                            <h1 class="positionHero__title uk-h1">{{ $parent.job.title }}</h1>
                        </div>
                    </div>
                </div>

                <div class="positionHero__bottom-with-text">
                    <div class="positionHero__bottom-with-text-pattern -desktop">
                        <img :src="base_url + '/assets/images/static/pattern-rows-green.svg'" alt="Pattern" />
                    </div>

                    <div class="positionHero__bottom-with-text-pattern -mobile">
                        <img :src="base_url + '/assets/images/static/pattern-rows-green.svg'" alt="Pattern" />
                    </div>

                    <div class="positionHero__bottom-with-text-content">
                        <div class="uk-container uk-flex uk-flex-column positionHero__bottom-with-text-content-wrapper">
                            <div class="positionHero__bottom-with-text-content-meta-data">
                                {{ deptinfo.short_description }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="uk-section uk-section-default resource-single-page single-resource">

            <div class="uk-container">
                <div class="uk-grid uk-grid-large" uk-grid>
                    <div class="uk-width-expand editor-content">
                        <div class="uk-width-expand uk-margin-remove-last-child">

                            <div class="job-description" v-if="decodeEntities($parent.job.JobDescription)" v-html="decodeEntities($parent.job.JobDescription)"></div>

                            <a :href="$parent.job.apply_url" target="_blank" class="uk-button uk-button-default">{{ $t("message.apply_now")}}</a>

                            <div class="single-resource__related-resources -desktop">
                                <related-positions 
                                    v-if="deptinfo.dept_ID"
                                    :department-id="deptinfo.post_name"
                                    :department-name="deptinfo.post_title"
                                    :current-job-id="id">
                                </related-positions>
                            </div>
                        </div>
                    </div>
                    <div class="uk-width-large dr-sidebar">
                        
                        <div class="sidebar">
                            <div class="uk-margin-large-bottom">
                                <h4 class="uk-text-sidebar-title uk-margin-small-bottom">{{ $tc("message.location", 0) }}</h4>
                                <div class="uk-card-body uk-card-light-gray">
                                    <div class="uk-text-with-bullet -black">
                                        {{ locationsText }}
                                    </div>
                                    
                                </div>
                            </div>

                            <div class="uk-margin-large-bottom">
                                <h4 class="uk-text-sidebar-title uk-margin-small-bottom">{{ deptinfo.post_title }}</h4>
                                <div class="uk-card-body uk-card-light-gray">
                                    <div class="uk-text-xsmall" v-if="deptinfo.post_content" v-html="deptinfo.post_content"></div>
                                </div>
                            </div>

                            <div class="uk-margin-large-bottom">
                                <h4 class="uk-text-sidebar-title uk-margin-small-bottom">{{ $t("message.core_values") }}</h4>
                                <div class="uk-card-body uk-card-light-gray">
                                    <div class="uk-text-xsmall uk-margin-small-bottom" v-html="$t('message.core_values_text')"></div>

                                    <div class="uk-margin-auto-top">
                                        <a :href="url_base + 'about-us'" class="uk-button uk-button-primary">{{ $t("message.learn_about_dr") }}</a>
                                    </div>
                                </div>
                            </div>


                            <!-- Share this position -->
                            <share-this :link="share_link" :title="share_title"></share-this>

                        </div>

                    </div>

                    <div class="single-resource__related-resources -mobile">
                        <related-positions 
                            v-if="deptinfo.dept_ID"
                            :department-id="deptinfo.post_name"
                            :department-name="deptinfo.post_title"
                            :current-job-id="id">
                        </related-positions>
                    </div>
                </div>
                
            </div>
        </section>

    </div>
</template>

<script>
  import JobItem from './JobItem.vue';
  import ShareThis from './Share.vue';
  import RelatedPositions from './RelatedPositions.vue';

  export default {
    name: 'JobPost',
    props: ['id', 'department', 'deptinfo', 'locations'],
    components: {
      'job-item': JobItem,
      'share-this': ShareThis,
      'related-positions': RelatedPositions,
    },
    data() {
      return {
        referer: window.careers_data.return_url,
      }
    },
    computed: {
      base_url: function() {
        return window.careers_data.template_url;
      },
      return_url: function(){
        return window.careers_data.return_url;
	  },
      url_base: function(){
        return window.careers_data.locale === 'en' ? '/' : '/jp/';
      },
      isMobile: function(){
        return this.windowWidth < 1024
      },
      is_show_dept_description: function(){
        return this.deptinfo.dept_ID === this.department;
      },
      share_link: function() {
        return window.location.href;
      },
      share_title: function() {
        return document.querySelector('meta[property="og:title"]').content;
      },
      locationsText: function() {
        if (Array.isArray(this.locations)) {
          return this.locations.join(' | ');
        }
        return '';
      }
    },
    methods: {
      decodeEntities: function(encodedString) {
        let textArea = document.createElement('textarea');
        textArea.innerHTML = encodedString;
        return textArea.value;
      },
      handleResize: function(event){
        this.windowWidth = event.currentTarget.innerWidth;
      },
    },
    mounted: function () {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize);
    }
  };
</script>
